import { DivRegistrationResult, readPdf } from './parsers/pdfParser';
import { isPortimaDocument, parsePortima } from './parsers/portimaParser';
import {
  isStandardDivDocument,
  parseStandardDiv
} from './parsers/standardDivParser';
import { isInmotivDocument, parseInmotiv } from './parsers/inmotivParser';

export async function parseDivRegistration(
  file: File
): Promise<DivRegistrationResult> {
  const pages = await readPdf(file);
  const text = pages.map(page => page.full).join('\n');

  if (isInmotivDocument(text)) return parseInmotiv(pages);
  if (isPortimaDocument(text)) return parsePortima(pages);
  if (isStandardDivDocument(text)) return parseStandardDiv(pages);

  // Fallback: try each parser until one finds usable data
  for (const parser of [parseStandardDiv, parsePortima, parseInmotiv]) {
    try {
      return parser(pages);
    } catch {
      // try next format
    }
  }
  throw new Error('Geen inschrijvingsgegevens gevonden in dit document.');
}
